import React from 'react';
import { useNavigate } from 'react-router-dom';
import ClinicalAudiogramPhotoReader from '../components/ClinicalAudiogramPhotoReader';

const ClinicalAudiogram = ({ t }) => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white pt-28 pb-32">
      <div className="max-w-3xl mx-auto px-6">
        <h1 className="text-4xl font-bold text-slate-900">
          {t?.clinicalAudiogramTitle || 'Lire un audiogramme clinique'}
        </h1>

        <p className="mt-4 text-slate-800 text-lg leading-relaxed max-w-2xl">
          {t?.clinicalAudiogramIntro ||
            "Si vous disposez d’un audiogramme réalisé par un ORL ou un audioprothésiste, Hearen peut essayer de le lire afin de construire une première synthèse de votre audition."}
        </p>

        <div className="mt-10">
          <ClinicalAudiogramPhotoReader t={t} />
        </div>

        <p className="mt-8 text-sm text-slate-600 leading-relaxed">
          {t?.clinicalAudiogramFooter ||
            "Hearen ne réalise pas un audiogramme. Il lit un document réalisé par un professionnel, puis vous demandera confirmation avant toute intégration à votre profil."}
        </p>
      </div>
    </div>
  );
};

export default ClinicalAudiogram;